import React, { useContext, useState } from 'react';
import { useFetch } from '../api/useFetch';
import { useUserContext } from './user_context';

export const DebtContext = React.createContext();


export const DebtProvider = ({ children }) => {


    const { btoken, stoken } = useUserContext();


    let data = { btoken, stoken };

    const {
        loading: debtLoading, data: allDebts, fetchData: getDebtData
    } = useFetch('/getDebtManagement', data);


    // Debtors
    const [showAddDebtor, setShowAddDebtor] = useState(false);
    const CloseAddDebtor = () => setShowAddDebtor(false);
    const openAddDebtor = () => setShowAddDebtor(true);

    const [showEditDebtor, setShowEditDebtor] = useState(false);
    const CloseEditDebtor = () => setShowEditDebtor(false);
    const openEditDebtor = () => setShowEditDebtor(true);


    // Creditors
    const [showAddCreditor, setShowAddCreditor] = useState(false);
    const CloseAddCreditor = () => setShowAddCreditor(false);
    const openAddCreditor = () => setShowAddCreditor(true);

    const [showEditCreditor, setShowEditCreditor] = useState(false);
    const CloseEditCreditor = () => setShowEditCreditor(false);
    const openEditCreditor = () => setShowEditCreditor(true);

    return (
        <DebtContext.Provider value={{

            showAddDebtor, CloseAddDebtor, openAddDebtor,
            showEditDebtor, CloseEditDebtor, openEditDebtor,

            showAddCreditor, CloseAddCreditor, openAddCreditor,
            showEditCreditor, CloseEditCreditor, openEditCreditor,

            debtLoading, allDebts, getDebtData,
        }}>
            {children}
        </DebtContext.Provider>
    );
};

// make sure use
export const useDebtContext = () => {
    return useContext(DebtContext);
};
